module.exports = __webpack_public_path__ + "img/typography-alignment.e07d026a.gif";